var _pattern, _mask, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 250,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "polkaDots",
    patternUnits: "userSpaceOnUse",
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2,
    fill: "#0060ff"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fadeGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "white",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    style: {
      stopColor: "white",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "white",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    style: {
      stopColor: "white",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    style: {
      stopColor: "white",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "fadeMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "url(#fadeGradient)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "url(#polkaDots)",
    mask: "url(#fadeMask)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 100,
    r: 80,
    fill: "rgb(234 242 255 / 73%)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPattern);
export default __webpack_public_path__ + "static/media/custom-pattern.e27446e5f3bc47572b67da61ebdf15f9.svg";
export { ForwardRef as ReactComponent };